import { FlightFragment } from '@websky/graphql';
import { SelectedFare } from '../../../../DesktopFlight/types';

export function transformSelectedFareToFlight(
	selectedFare: SelectedFare,
	segmentGroups: FlightFragment['segmentGroups']
): FlightFragment {
	return {
		...selectedFare.flightInfo,
		segmentGroups,
		fares: []
	};
}
